import { buildTranslate } from 'locales'
import AccordionButton from '../Bar/AccordionButton'
import MenuItem from '../Bar/MenuItem'
import SettingsContent from './Content'

const t = buildTranslate('nav.settings_menu')

type SettingsProps = {
  isLeftNav?: boolean
  onClick?: () => void
  paths: string[]
}

const Settings = ({
  isLeftNav = false,
  onClick = () => {},
  paths,
}: SettingsProps) => {
  const Parent = isLeftNav ? AccordionButton : MenuItem

  // Parent is always enabled — individual flyout items handle their own permission gating
  return (
    <Parent paths={paths} disabled={false} buttonContents={t('button')}>
      <SettingsContent isLeftNav={isLeftNav} onClick={onClick} />
    </Parent>
  )
}

export default Settings
